'use client';

import { usePopupConfirmContext } from '@/contexts/popup';
import { Button } from '../Button';
import { Modal } from '../Modal/Modal';

export const PopupConfirm = () => {
	const { isOpen, title, message, onConfirm, hide } = usePopupConfirmContext();

	return (
		<Modal
			isOpen={isOpen}
			onClose={hide}
			showCloseIcon={false}
			size="sm"
			title={
				<h3 className="text-lg font-semibold text-[var(--color-base-black)]">
					{title}
				</h3>
			}
		>
			<div className="flex flex-col gap-6">
				{/* Message */}
				<p className="text-[var(--color-base-black)] text-center">{message}</p>

				{/* Action Buttons */}
				<div className="flex gap-3 flex-col">
					<Button fullWidth type="button" variant="outline" onClick={onConfirm}>
						OK
					</Button>
				</div>
			</div>
		</Modal>
	);
};
